import { render } from "./overview-list.vue?vue&type=template&id=4b7aafad&ts=true"
import script from "./overview-list.ts?vue&type=script&lang=ts&external"
export * from "./overview-list.ts?vue&type=script&lang=ts&external"

import "./overview-list.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__